import React from 'react';
import { useDispatch } from 'react-redux';
import { InternalLink, SimpleFlexbox, FadeIn } from 'ctm-components';
import styles from './car_badge_unsure.css';

const CarBadgeUnsure = (props) => {
    const dispatch = useDispatch();
    /**
     * Render the component.
     * @returns {Node} - return the the unsure / no badge text component
     */
    return (
        <SimpleFlexbox className={styles.footer_link}>
            <FadeIn>
                <span>If your car has no badge or you are unsure, </span>
                <InternalLink
                    variant="bold_underline"
                    data-id="car_manual_lookup"
                    onClick={() => dispatch({
                        type: 'SET_FORM_VALUE',
                        value: 'ALL_BADGES',
                        stateKey: 'vertical.quote',
                        identifier: 'coverDetail.vehicle.badge'
                    })}
                    href="/car-insurance/journey/car_series"
                >
                    click here
                </InternalLink>
            </FadeIn>
        </SimpleFlexbox>
    );
};

export { CarBadgeUnsure };
